import { FC } from 'react';

import RadioGroup, { RadioGroupProps } from 'components/RadioGroup';

type Props = Omit<RadioGroupProps, 'label' | 'options'>;

const options = [
  { value: 'PLANE', label: 'Lėktuvas' },
  { value: 'BUS', label: 'Autobusas' },
  { value: 'SHIP', label: 'Laivas' },
];

const TransportTypeRadioGroup: FC<Props> = props => (
  <RadioGroup {...props} label="Transporto rūšis" options={options} />
);

export default TransportTypeRadioGroup;
